<template>
  <section>
    <b-container fluid>
      <b-row align-v="start" class="section-title">
        <b-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
          <h2>Réinitialisez votre mot de passe</h2>
        </b-col>
      </b-row>
      <b-row align-v="center" class="section-content">
        <b-col
          cols="12"
          sm="10"
          offset-sm="1"
          md="8"
          offset-md="2"
          lg="6"
          offset-lg="3"
          xl="4"
          offset-xl="4"
        >
          <b-card>
            <b-form @submit.prevent="onSubmit">
              <b-form-group id="passwordResetInputGroup">
                <b-input-group>
                  <b-input-group-prepend is-text>
                    <i class="fa fa-key fa-lg fa-fw"></i>
                  </b-input-group-prepend>
                  <b-form-input
                    id="passwordResetInput"
                    name="user.password"
                    :type="showPass ? 'text' : 'password'"
                    maxlength="255"
                    v-model="user.password"
                    v-validate="{required: true, min:8}"
                    :state="!errors.has('user.password')"
                    aria-describedby="passwordLiveFeedback passwordLiveHelp"
                    placeholder="Mot de passe"
                    data-vv-as="&quot;Mot de passe&quot;"
                    size="lg"
                  />
                  <b-input-group-append>
                    <b-btn
                      variant="primary"
                      @click="showPass = !showPass"
                    >{{showPass ? 'Masquer' : 'Afficher' }}</b-btn>
                  </b-input-group-append>
                  <b-form-invalid-feedback
                    id="passwordLiveFeedback"
                    v-if="errors.has('user.password')"
                  >{{ errors.first('user.password') }}</b-form-invalid-feedback>
                </b-input-group>
                <b-form-text
                  id="passwordLiveHelp"
                >Entrez un mot de passe contenant au minimum 8 caractères.</b-form-text>
              </b-form-group>
              <b-button
                type="submit"
                variant="primary"
                size="lg"
                :disabled="status.changingPassword"
              >
                Valider
                <i class="fa fa-check fa-lg fa-fw"></i>
              </b-button>
              <i v-show="status.changingPassword" class="loader fa fa-spinner fa-spin fa-2x"></i>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "PasswordReset",
  data: function() {
    return {
      showPass: false
    };
  },
  computed: {
    ...mapState("account", ["status", "user"])
  },
  methods: {
    ...mapActions("account", ["passwordUpdate"]),
    onSubmit() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.passwordUpdate({
            token: this.$route.params.token,
            password: this.user.password
          });
        }
      });
    }
  }
};
</script>

<style>
.input-group-append .btn {
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}
</style>

